module.exports = __webpack_public_path__ + "img/Hoogspanning1.5adc51d7.jpg";